/* Copyright Information: Created by BuyGroup */
import createDOMPurify from "dompurify";

const htmlOnlyOptions = {
  USE_PROFILES: { html: true },
};

const getDOMPurify = () => {
  if (createDOMPurify && createDOMPurify.sanitize) {
    return createDOMPurify;
  }

  if (typeof window !== "undefined") {
    return createDOMPurify(window);
  }

  return null;
};

export const sanitizeProductSpecification = (html) => {
  const purifier = getDOMPurify();
  if (!purifier) {
    return "";
  }

  return purifier.sanitize(String(html == null ? "" : html), htmlOnlyOptions);
};

const escapeHtmlText = (value) => {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
};

export const createAmazonSpecificationHtml = (specifications) => {
  if (!specifications || typeof specifications !== "object") {
    return "";
  }

  const specsHtml = Object.entries(specifications)
    .map(
      ([key, value]) =>
        `<strong>${escapeHtmlText(key)}:</strong> ${escapeHtmlText(value)}`
    )
    .join("<br>");

  return sanitizeProductSpecification(specsHtml);
};
/* Copyright Information: Created by BuyGroup */
